import $ from 'jquery';

// open usercentrics cookie-consent-tool
$('.js-cookie-consent-tool').on('click', (event) => {
    event.preventDefault();

    if (typeof UC_UI !== 'undefined') {
        UC_UI.showSecondLayer();
    }
});
